import React, { useEffect, useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import { Col, Row } from 'antd';
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce';

// ROUTES
import { useHistory } from 'react-router-dom';
import { ROUTE_SECRETARIA_EDUCACAO } from 'routes/paths';
import { ROUTE_SECRETARIA_EDUCACAO_CANCELAMENTO_PESQUISAR_ALUNO } from 'pages/EducacaoUpdate/routes/paths';

// REDUX
import { ApplicationState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { consultarInscricaoClear } from 'store/modules/api/educacaoUpdate/inscricao/consultarInscricao/actions';
import { removerInscricaoRequest } from 'store/modules/api/educacaoUpdate/inscricao/removerInscricao/actions';
import { eventosPPTContabilizacaoRequest } from 'store/modules/api/utils/eventosPPT/contabilizacao/actions';
import { estatisticaIncluirRequest } from 'store/modules/api/sguService/estatisticasIncluir/actions';

// UTILS
import { formatDate } from 'utils/genericFunctions';
import { treatRequestEventsContabilizacaoPPT } from 'utils/functions/treatEventosPPTRequest';
import { treatRequestSguEducacaoResponseEvents } from 'pages/DetranCnh/utils/functions/sguStatistics/treatServiceRequest';

// COMPONENTS
import Section from 'components/Common/Section';
import Alert from 'components/Common/Notifications/Alert';
import Button from 'components/Common/Button';
import { ContentButton } from 'pages/iirgd/Aac/Numeral/Consultar/styled';
import ButtonVoltar from 'components/Common/ButtonVoltar';
import {
	CANCELA_INSCRICAO_ALUNO,
	CANCELA_INSCRICAO_ALUNO_ID_SERVICO,
	CANCELA_INSCRICAO_ALUNO_DESCRICAO,
	ID_ORGAO_EDUCACAO,
} from 'pages/EducacaoUpdate/tiposEventos';
import DadosPessoais from './DadosPessoais';
import Documentos from './Documentos';
import DadosInscricao from './DadosInscricao';

// FORM
import { IVisualizarFicha, initialValues } from './form';

const VizualizaFichaAluno = () => {
	const [InitialValues, setInitialValues] = useState(initialValues);
	const [inscricaoRemovida, setInscricaoRemovida] = useState(false);

	const dispatch = useDispatch();
	const history = useHistory();
	const { token } = useContext<IAuthContext>(AuthContext);

	const { consultaFichaAluno } = useSelector(
		(state: ApplicationState) => state.api.educacaoUpdate.fichaAluno,
	);

	const { consultarInscricao, removerInscricao } = useSelector(
		(state: ApplicationState) => state.api.educacaoUpdate.inscricao,
	);

	const { data: dataSalvarAtendimento } = useSelector(
		(state: ApplicationState) => state.api.sgu.atendimento.salvarAtendimento,
	);

	const { loginUnico, atendimento } = useSelector(
		(state: ApplicationState) => state.api.sgu,
	);

	const { eventosPPTContabilizacao } = useSelector(
		(state: ApplicationState) => state.api.utils,
	);

	const { estatisticasIncluir } = useSelector(
		(state: ApplicationState) => state.api.sguService,
	);

	useEffect(() => {
		if (consultaFichaAluno.data) {
			const { dadosPessoais, justificativaDocumentos } =
				consultaFichaAluno.data;

			if (dadosPessoais) {
				// Aluno
				initialValues.aluno.numeroRA = dadosPessoais?.numRA?.trim() || '';
				initialValues.aluno.digitoRA = dadosPessoais?.digitoRA?.trim() || '';
				initialValues.aluno.siglaUFRA = dadosPessoais?.siglaUFRA?.trim() || '';
			}

			const { documentos } = consultaFichaAluno.data;
			// Documentos
			initialValues.documentos.codigoINEP = documentos?.codigoINEP || '';
			initialValues.documentos.cpf = documentos?.cpf || '';
			initialValues.documentos.numeroDocumentoCivil =
				documentos?.numDocumentoCivil || '';
			initialValues.documentos.digitoDocumentoCivil =
				documentos?.digitoDocumentoCivil || '';
			initialValues.documentos.ufDocumentoCivil =
				documentos?.ufDocumentoCivil || '';
			initialValues.documentos.dataEmissaoDocumentoCivil =
				formatDate(documentos.dataEmissaoDocumentoCivil) || '';
			initialValues.documentos.dataEmissaoCertidao =
				formatDate(documentos.dataEmissaoCertidao) || '';
			initialValues.documentos.numeroNIS = documentos?.numeroNis || '';
			initialValues.documentos.numeroRG = documentos?.numDocumentoCivil || '';
			initialValues.documentos.digitoRG =
				documentos?.digitoDocumentoCivil || '';
			initialValues.documentos.ufRG = documentos?.ufDocumentoCivil || '';
			initialValues.documentos.justificativaDocumentos =
				justificativaDocumentos || '';
			initialValues.documentos.tipoCertidao = '';

			// Dados Pessoais
			initialValues.dadosPessoais.numeroRA = dadosPessoais?.numRA?.trim() || '';
			initialValues.dadosPessoais.digitoRA =
				dadosPessoais?.digitoRA?.trim() || '';
			initialValues.dadosPessoais.siglaUFRA =
				dadosPessoais?.siglaUFRA?.trim() || '';
			initialValues.dadosPessoais.nomeAluno = dadosPessoais?.nomeAluno || '';
			initialValues.dadosPessoais.dataNascimento =
				formatDate(dadosPessoais.dataNascimento) || '';
			initialValues.dadosPessoais.corRaca = dadosPessoais?.corRaca || '';
			initialValues.dadosPessoais.descricaoCorRaca =
				dadosPessoais?.corRaca || '';
			initialValues.dadosPessoais.codigoSexo = dadosPessoais?.codSexo || '';
			initialValues.dadosPessoais.sexo = dadosPessoais?.sexo || '';
			initialValues.dadosPessoais.nomeMae = dadosPessoais?.nomeMae || '';
			initialValues.dadosPessoais.nomePai = dadosPessoais?.nomePai || '';
			initialValues.dadosPessoais.nomeSocial = dadosPessoais?.nomeSocial || '';
			initialValues.dadosPessoais.nomeAfetivo =
				dadosPessoais?.nomeAfetivo || '';
			initialValues.dadosPessoais.email = dadosPessoais?.email || '';
			initialValues.dadosPessoais.nacionalidade =
				dadosPessoais?.nacionalidade || '';
			initialValues.dadosPessoais.descricaoNacionalidade =
				dadosPessoais?.descricaoNacionalidade || '';
			initialValues.dadosPessoais.codigoPaisOrigem =
				dadosPessoais?.codPaisOrigem || '';
			initialValues.dadosPessoais.nomePaisOrigem =
				dadosPessoais?.paisOrigem || '';
			initialValues.dadosPessoais.dataEntradaPais =
				formatDate(dadosPessoais.dataEntradaPais) || '';
			initialValues.dadosPessoais.bolsaFamilia = dadosPessoais?.bolsaFamilia
				? 'S'
				: '';
			initialValues.dadosPessoais.quilombola = dadosPessoais?.quilombola
				? 'S'
				: '';
			initialValues.dadosPessoais.nomeMunicipioNascimento =
				dadosPessoais?.nomeMunicipioNascimento || '';
			initialValues.dadosPessoais.ufMunicipioNascimento =
				dadosPessoais?.ufMunicipioNascimento || '';
			initialValues.dadosPessoais.alunoFalecido = dadosPessoais?.alunoFalecido
				? 'S'
				: '';
			initialValues.dadosPessoais.dataFaleciomento =
				formatDate(dadosPessoais.dataFalecimento) || '';
			initialValues.dadosPessoais.codigoBolsaFamilia = false;
			initialValues.dadosPessoais.possuiInternet = dadosPessoais?.possuiInternet
				? 'S'
				: '';
			initialValues.dadosPessoais.possuiNotebookSmartphoneTablet =
				dadosPessoais?.possuiNotebookSmartphoneTablet ? 'S' : '';

			if (
				consultaFichaAluno.data.certidaoAntiga?.numCertidao &&
				consultaFichaAluno.data.certidaoAntiga.numCertidao !== ''
			) {
				const { certidaoAntiga } = consultaFichaAluno.data;
				initialValues.documentos.tipoCertidao = 'ANTIGA';
				initialValues.certidaoAntiga.numeroCertidao =
					certidaoAntiga?.numCertidao || '';
				initialValues.certidaoAntiga.numeroLivroRegistro =
					certidaoAntiga?.livro || '';
				initialValues.certidaoAntiga.numeroFolhaRegistro =
					certidaoAntiga?.folha || '';
				initialValues.certidaoAntiga.nomeMunicipioComarca =
					certidaoAntiga?.municipioComarca || '';
				initialValues.certidaoAntiga.ufComarca =
					certidaoAntiga?.ufComarca || '';
				initialValues.certidaoAntiga.distritoNascimento =
					certidaoAntiga?.distritoCertidao || '';
				initialValues.certidaoAntiga.dataEmissaoCertidao =
					formatDate(documentos.dataEmissaoCertidao) || '';
			} else if (
				consultaFichaAluno.data.certidaoNova?.certMatr01 &&
				consultaFichaAluno.data.certidaoNova.certMatr01 !== ''
			) {
				const { certidaoNova } = consultaFichaAluno.data;
				initialValues.documentos.tipoCertidao = 'NOVA';
				initialValues.certidaoNova.certificadoMatricula01 =
					certidaoNova?.certMatr01 || '';
				initialValues.certidaoNova.certificadoMatricula02 =
					certidaoNova?.certMatr02 || '';
				initialValues.certidaoNova.certificadoMatricula03 =
					certidaoNova?.certMatr03 || '';
				initialValues.certidaoNova.certificadoMatricula04 =
					certidaoNova?.certMatr04 || '';
				initialValues.certidaoNova.certificadoMatricula05 =
					certidaoNova?.certMatr05 || '';
				initialValues.certidaoNova.certificadoMatricula06 =
					certidaoNova?.certMatr06 || '';
				initialValues.certidaoNova.certificadoMatricula07 =
					certidaoNova?.certMatr07 || '';
				initialValues.certidaoNova.certificadoMatricula08 =
					certidaoNova?.certMatr08 || '';
				initialValues.certidaoNova.certificadoMatricula09 =
					certidaoNova?.certMatr09 || '';
			} else {
				initialValues.documentos.tipoCertidao = '';
			}

			if (consultarInscricao.data) {
				const { inscricaoSelecionada } = consultarInscricao.data;
				// DADOS DA INSCRIÇÃO
				initialValues.inscricoes.codigoEscola =
					inscricaoSelecionada?.codigoEscola || '';
				initialValues.inscricoes.tipo = inscricaoSelecionada?.tipo || '';
				initialValues.inscricoes.descricaoTipo =
					inscricaoSelecionada?.descricaoTipo || '';
				initialValues.inscricoes.situacao =
					inscricaoSelecionada?.situacao || '';
			}

			if (consultarInscricao.request) {
				const { anoLetivo, numeroRA, digitoRA, siglaUFRA } =
					consultarInscricao.request;
				// DADOS DA INSCRIÇÃO
				initialValues.dadosRequisicaoInscricao.anoLetivo = anoLetivo || '';
				initialValues.dadosRequisicaoInscricao.numeroRA = numeroRA || '';
				initialValues.dadosRequisicaoInscricao.digitoRA = digitoRA || '';
				initialValues.dadosRequisicaoInscricao.siglaUF = siglaUFRA || '';
			}

			setInitialValues(initialValues);
		}
	}, [
		consultaFichaAluno.data,
		consultarInscricao.data,
		consultarInscricao.request,
	]);

	const handleSubmit = (values: IVisualizarFicha) => {
		const dataRequest = {
			aluno: {
				numeroRA: values.dadosRequisicaoInscricao.numeroRA.toString(),
				digitoRA: values.dadosRequisicaoInscricao.digitoRA.toString(),
				siglaUFRA: values.dadosRequisicaoInscricao.siglaUF.toString(),
			},
			anoLetivo: values.dadosRequisicaoInscricao.anoLetivo.toString(),
			codigoEscola: values.inscricoes.codigoEscola.toString(),
			tipoInscricao: values.inscricoes.tipo.toString(),
		};
		dispatch(removerInscricaoRequest(token, dataRequest));
	};

	useEffect(() => {
		if (removerInscricao.status === 200 || removerInscricao.status === 201) {
			window.scrollTo(0, 0);
			setInscricaoRemovida(true);
			if (eventosPPTContabilizacao.status === 0) {
				const treatedEventsPPTRequest = treatRequestEventsContabilizacaoPPT(
					atendimento,
					loginUnico,
					consultaFichaAluno.data?.documentos?.cpf || '',
					'EDUCAÇÃO',
					ID_ORGAO_EDUCACAO,
					CANCELA_INSCRICAO_ALUNO_DESCRICAO,
					Number(CANCELA_INSCRICAO_ALUNO_ID_SERVICO),
					CANCELA_INSCRICAO_ALUNO,
				);
				dispatch(
					eventosPPTContabilizacaoRequest(token, treatedEventsPPTRequest),
				);
			}
		}
	}, [
		removerInscricao,
		eventosPPTContabilizacao.status,
		consultaFichaAluno.data,
		dispatch,
		atendimento,
		loginUnico,
		token,
	]);

	useEffect(() => {
		if (
			eventosPPTContabilizacao.status !== 0 &&
			eventosPPTContabilizacao.status !== 100
		) {
			if (estatisticasIncluir.status === 0) {
				const payload = treatRequestSguEducacaoResponseEvents(
					loginUnico,
					atendimento,
					dataSalvarAtendimento?.cpf || '',
					eventosPPTContabilizacao.status === 200,
					CANCELA_INSCRICAO_ALUNO,
					Number(CANCELA_INSCRICAO_ALUNO_ID_SERVICO),
					CANCELA_INSCRICAO_ALUNO_DESCRICAO,
				);
				dispatch(estatisticaIncluirRequest(token, payload));
			}
		}
	}, [
		eventosPPTContabilizacao.status,
		estatisticasIncluir.status,
		dataSalvarAtendimento,
		dispatch,
		atendimento,
		loginUnico,
		token,
	]);

	return (
		<>
			<Formik
				enableReinitialize
				validateOnChange={false}
				validateOnBlur={false}
				initialValues={InitialValues}
				onSubmit={values => handleSubmit(values)}
			>
				{formik => (
					<>
						<Form autoComplete="off">
							{inscricaoRemovida && (
								<Row gutter={[0, 20]}>
									<Col span={24}>
										<Alert
											type="info"
											message={<p>Inscrição removida com sucesso!</p>}
											onClose={() => setInscricaoRemovida(false)}
										/>
									</Col>
								</Row>
							)}
							<Section title="Ficha Aluno">
								<Col span={24}>
									<Row gutter={[0, 20]}>
										<Col span={24}>
											<DadosPessoais formik={formik} />
										</Col>
									</Row>
									<Row gutter={[0, 20]}>
										<Col span={24}>
											<Documentos formik={formik} />
										</Col>
									</Row>
									<Row gutter={[0, 20]}>
										<Col span={24}>
											<DadosInscricao formik={formik} />
										</Col>
									</Row>
								</Col>
								<ContentButton justify="center">
									{!inscricaoRemovida ? (
										<Button
											onClick={() => {
												formik.handleSubmit();
											}}
										>
											Cancelar Inscrição
										</Button>
									) : (
										<Button
											onClick={() => {
												history.push(ROUTE_SECRETARIA_EDUCACAO);
												dispatch(consultarInscricaoClear());
											}}
										>
											Encerrar
										</Button>
									)}
								</ContentButton>
							</Section>
							<ButtonVoltar
								navigate={false}
								onClick={() => {
									dispatch(consultarInscricaoClear());
									history.push(
										ROUTE_SECRETARIA_EDUCACAO_CANCELAMENTO_PESQUISAR_ALUNO,
									);
								}}
							/>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default VizualizaFichaAluno;
